export const GET_TRANSACTION_SOURCE_DEF= "GET_TRANSACTION_SOURCE_DEF"
export const GET_TRANSACTION_SOURCE_DEF_SUCCESS = "GET_TRANSACTION_SOURCE_DEF_SUCCESS"
export const GET_TRANSACTION_SOURCE_DEF_FAIL = "GET_TRANSACTION_SOURCE_DEF_FAIL"

export const TRANSACTION_SOURCE_DEF_API_ERROR = "API_ERROR"